import clone from 'clon'

import {SpriteName} from 'airship/patterns/types'
import getUiUrl from 'airship/modules/ui-url'

export interface JourneyTemplate {
  description: string
  title: string
  templateName: string
  icon: SpriteName
  heroURL: string
  heroAltText: string
  // Indicates if the template should show in the push popover when clicking
  // the create new message icon in the header navigation.
  inPushPopover: boolean
}

export const MAP_TRIGGERED_JOURNEY_TEMPLATES: Readonly<JourneyTemplate>[] = [
  {
    templateName: 'welcome-series-map',
    title: 'Welcome Series',
    description:
      'Automatically welcome new customers to your app with a series of onboarding messages.',
    icon: 'welcome-series',
    heroURL: `${getUiUrl()}images/journey-template--welcome.jpg`,
    heroAltText: 'Welcome series template',
    inPushPopover: true,
  },
  {
    templateName: 'inactivity-map',
    title: 'Re-engagement sequence',
    description:
      'Proactively try to win back audience members who have become inactive with your app.',
    icon: 'reengagement-journey',
    heroURL: `${getUiUrl()}images/journey-template--reengagement.jpg`,
    heroAltText: 'Re-engagement series',
    inPushPopover: true,
  },
  {
    templateName: 'authentication-map',
    title: 'Authentication sequence',
    description: 'Encourage anonymous users to log in to your app.',
    icon: 'attention',
    heroURL: `${getUiUrl()}images/journey-template--authentication.jpg`,
    heroAltText: 'Hero alt text description',
    inPushPopover: false,
  },
]

export const getJourneyTemplates = (
  inPushPopover = false
): Readonly<JourneyTemplate>[] => {
  let templates = clone(MAP_TRIGGERED_JOURNEY_TEMPLATES)

  if (inPushPopover) {
    templates = templates.filter((template) => template.inPushPopover === true)
  }

  return templates
}
